
import { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faqsApi, type Faq } from "@/integrations/mysql/client";
import { usePageContent } from "@/hooks/usePageContent";

export function FAQ({ className = "bg-[#f4fbf7]" }: { className?: string }) {
  const [faqs, setFaqs] = useState<Faq[]>([]);
  const [loading, setLoading] = useState(true);
  const { getText } = usePageContent('home');

  const sectionLabel = getText('faq', 'label',    'Dúvidas Frequentes');
  const title        = getText('faq', 'title',    'Perguntas Frequentes');
  const subtitle     = getText('faq', 'subtitle', 'Tire suas dúvidas sobre os atendimentos');

  useEffect(() => {
    faqsApi.list()
      .then(setFaqs)
      .catch((err) => console.error('Erro ao carregar FAQs:', err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <section id="faq" className={`py-20 ${className}`}>
        <div className="container mx-auto px-6">
          <div className="text-center">
            <p className="text-gray-500">Carregando perguntas frequentes...</p>
          </div>
        </div>
      </section>
    );
  }

  if (faqs.length === 0) {
    return null;
  }

  return (
    <section id="faq" className={`py-20 ${className}`}>
      <div className="container mx-auto px-6">
        <div className="text-center mb-14">
          <p className="section-label mb-3">{sectionLabel}</p>
          <h2 className="section-heading mb-3">{title}</h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto font-primary font-light">
            {subtitle}
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          {/* Each FAQ is its own Accordion inside a CSS grid — grid equalizes row heights */}
          <div className="grid md:grid-cols-2 gap-3 items-start">
            {faqs.map((faq, index) => (
              <Accordion key={faq.id} type="single" collapsible>
                <AccordionItem
                  value={`item-${index}`}
                  className="bg-white rounded-xl border border-gray-100 px-5 shadow-sm data-[state=open]:shadow-md data-[state=open]:border-brand-primary/20 transition-all h-full"
                >
                  <AccordionTrigger className="text-left font-bold font-primary text-sm text-gray-800 hover:text-brand-primary hover:no-underline min-h-[64px] py-4">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-500 font-primary font-light text-sm leading-relaxed pb-4">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
